// extracted by mini-css-extract-plugin
export default {"container":"styles__container--jPV4Z","small":"styles__small--a9IXN","medium":"styles__medium--JkyPa","large":"styles__large--pGcnv","star":"styles__star--G4FSG"};